/**
 * Generates a project name matching the SQL backfill pattern:
 * {businessname}:{eventId} {PO} {city}
 * PO and city are included only when non-empty.
 */
export const generateProjectName = ({
  businessName,
  eventId,
  po,
  city,
}: {
  businessName: string;
  eventId: number;
  po?: string;
  city?: string;
}): string => {
  let name = `${businessName}:${eventId}`;

  const hasPo = po && po.trim() !== '';
  const hasCity = city && city.trim() !== '';

  if (hasPo && hasCity) {
    name += ` ${po.trim()} ${city.trim()}`;
  } else if (hasPo) {
    name += ` ${po.trim()}`;
  } else if (hasCity) {
    name += ` ${city.trim()}`;
  }

  return name;
};
